// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"ec0cf330","498":"f67a0617","703":"66fa7141","787":"566f2e46"}[chunkId] + ".chunk.js";
};